export * from './lib/components/search/search.component';
